import { keyframes, styled } from '@mui/material';
import { Colors } from 'library';

export const IconCircle = styled('div')<{ size?: number }>(({ size = 40 }) => ({
    width: size,
    height: size,
    borderRadius: '50%',
    backgroundColor: Colors.turquoise,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
}));

const fadeSlideUp = keyframes`
    from {
        opacity: 0;
        transform: translateY(16px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const scaleIn = keyframes`
    from {
        opacity: 0;
        transform: scale(0.8);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
`;

export const FadeSlideIn = styled('div')<{ delay?: number }>(({ delay = 0 }) => ({
    opacity: 0,
    animation: `${fadeSlideUp} 0.4s ease-out ${delay}ms forwards`,
}));

export const AnimatedLogo = styled('img')<{ width?: number }>(({ width = 60 }) => ({
    width,
    marginBottom: 12,
    opacity: 0,
    animation: `${scaleIn} 0.5s ease-out 100ms forwards`,
}));

export const HeaderSection = styled('div')({
    background: `linear-gradient(135deg, ${Colors.darkNavy} 0%, ${Colors.darkNavy} 100%)`,
    padding: '36px 30px 28px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    borderBottom: `1px solid ${Colors.lightGrey}`,
});

export const ModalBody = styled('div')({
    padding: '24px 30px 30px',
});

export const PartnershipCard = styled('div')({
    backgroundColor: '#FBF6EE',
    borderRadius: 12,
    padding: 20,
    marginBottom: 20,
    border: `1px solid ${Colors.lightGrey}`,
});

export const BenefitsList = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: 14,
    marginBottom: 10,
});

export const BenefitItem = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: 12,
});
